import React from 'react'
import css from "./Hero.module.css"
import HeroImg from "../../assets/hero.png"
import {RiShoppingBagFill} from "react-icons/ri";
import { BsArrowRight } from "react-icons/bs";
import { motion } from 'framer-motion';
const Hero = () => {
    const transition={duration:3, type:"spring"}
  return (
<div className={css.container}>

    <div className={css.h_sides}>
        <span class={css.text1}>Skin protection cream</span>
<div className={css.text2}>
<span>Trendy collection</span>
<span>Trendy collection is now for sale at only 50£.Trendy collection is now for sale at only 50£</span>
</div>
    </div>

 <div className={css.wrapper}>
    <motion.div 
    initial={{bottom:"2rem"}}
    transition={transition}
     whileInView={{bottom:"0rem"}} 
     className={css.circle}>    </motion.div>
    <motion.img  
        initial={{bottom:"-2rem"}}
        transition={transition}
         whileInView={{bottom:"0rem"}} 
    src={HeroImg} width={400} />
<motion.div
initial={{right:"2rem"}}
transition={transition}
 whileInView={{right:"0rem"}} 
className={css.cart}>
    <RiShoppingBagFill/>
    <div className={css.signUp}>
        <span>Best sign-up Offers.</span>
        <div>
            <BsArrowRight/>
        </div>
    </div>
</motion.div>
</div>
 
<div className={css.h_sides}>
    <div className={css.traffic}>
        <span>1M</span>
        <span>Monthly Traffic</span>
    </div>

    <div className={css.traffic}>
    <span>50.2K</span>
        <span>Happy Customers</span>
    </div>
</div>

</div>
    )
}

export default Hero